import * as React from 'react';

import { CombinedProductionViewProps } from '../../components/list/production';
import ListPerformances from '../../components/list/performances';


const ListMonthsView: React.StatelessComponent<CombinedProductionViewProps> = props => {
    const pdpHeader = (
        <div>
            
            <h2 className="h3-style" id={`Prod-Group-${props.production.productionTitle}`} dangerouslySetInnerHTML={{ __html: props.production.productionTitle }}>
            </h2>
        </div>
    );
    return (
        <li className="ace-subs-item">
            <div className="ace-subs-item-inner">
                {
                    props.production.pdpImageSrc && props.production.pdpImageSrc != "" ?
                        <div><img src={props.production.pdpImageSrc} alt={`${props.production.productionTitle}`} /></div>
                        :
                        null
                }
                <div>
                    <div className="ace-subs-item-top">
                        <div>
                            <p className="pretitle">
                                {props.production.dateRangeString}
                            </p>
                            {pdpHeader}
                        </div>
                    </div>
                    <div className="stack-sm">
                    {props.production.productionSeasonDescription && <p className="large">{props.production.productionSeasonDescription}</p>}
                    {props.production.productionSynopsis ?
                        <div className="stack-sm">
                            {
                                props.text.synopsisHeaderLabel !== "" &&
                                <h3>{props.text.synopsisHeaderLabel}</h3>
                            }
                                <div className="rich-text" dangerouslySetInnerHTML={{ __html: props.production.productionSynopsis }}></div>
                        </div>
                        : null
                        }
                    </div>
                </div>
            </div>
            <div className="accordion-list space-top-lg">
                <div className="accordion-list-item ace-subs-accordion-item">
                    <button className="accordion-trigger" aria-expanded={`${props.showPerformances ? 'true' : 'false'}`}
                        onClick={props.toggleShowPerformances}>
                        {
                            props.showPerformances ? props.text.hidePerformancesButtonText
                                : props.text.viewPerformancesButtonText
                        }
                    </button>
                </div>
            </div>

            <div className="accordion-panel" aria-hidden={!props.showPerformances}>
                <div className="accordion-panel-content">
                    <ListPerformances filteredPerformances={props.filteredPerformances} />
                </div>
            </div>
        </li>
    );
}

export default ListMonthsView;